// extracted by mini-css-extract-plugin
export default {"root":"Filter_root__qc9EE","active":"Filter_active__l3m7J"};